import { SvgIcon, SvgIconProps, useTheme } from "@mui/material";

export const ArrowSplideLeft = (props: SvgIconProps) => {
   const theme = useTheme();
  return (
    <SvgIcon
      width={props.width || 24}
      height={props.height || 24}
      viewBox="0 0 320 512"
      {...props}
    >
      <path
         fill={props.htmlColor || theme.palette.secondary[500]}
       d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"
      />
      <path opacity={1} d="" />
    </SvgIcon>
  );
};
